<template>
  <div>
    <div class="modal-title">{{ place.name }}</div>
    <div class="modal-content">
      <div v-if="place.images && place.images.length > 0" class="modal-detail text-center">
        <img v-lazy="place.images[imageIndex]" class="place-image" />
        <div v-if="place.images.length >= 2">
          <span><a @click="prevImage" class="text-gray-600 text-sm" :class="imageIndex > 0 ? 'visible' : 'invisible'">＜ 前の画像</a></span>
          ({{ imageIndex + 1 }}/{{ place.images.length }})
          <span><a @click="nextImage" class="text-gray-600 text-sm" :class="imageIndex < place.images.length - 1 ? 'visible' : 'invisible'">次の画像 ＞</a></span>
        </div>
      </div>
      <p class="modal-comment" v-html="place.detail"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PoiDetail',
  props: {
    place: {
      type: Object,
      default: function () {
        return {
          id: null,
          name: null,
          detail: null
        }
      }
    }
  },
  data () {
    return {
      imageIndex: 0
    }
  },
  methods: {
    prevImage: function () {
      this.imageIndex--
    },
    nextImage: function () {
      this.imageIndex++
    }
  }
}
</script>
